import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Logo from "@/assets/img/sublogoPRed.png";
import { useAuth } from "@/hooks/use-auth";

import { AppSidebar } from "../app-sidebar";
import { SidebarInset, SidebarProvider, SidebarTrigger } from "../ui/sidebar";

export function MainContent({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated()) {
      logout();
      navigate("/");
    }
  }, []);

  return (
    <div className="flex min-h-screen w-full flex-col">
      <SidebarProvider
        style={
          {
            "--sidebar-width": "19rem",
          } as React.CSSProperties
        }
      >
        <AppSidebar />

        <SidebarInset className="p-8 border">
          <MobileHeader />

          {children}
        </SidebarInset>
      </SidebarProvider>
    </div>
  );
}

function MobileHeader() {
  return (
    <div className="md:hidden sticky top-5 flex gap-8 justify-between bg-background/20 backdrop-blur-xs rounded-xl border p-4 mb-2 z-50">
      <img src={Logo} alt="Logo" className="h-6 w-6" />

      <SidebarTrigger />
    </div>
  );
}
